import cx from 'classnames'
import { useButton } from '@react-aria/button'
import { mergeProps } from '@react-aria/utils'
import { forwardRef, PointerEvent } from 'react'
import { useObjectRef } from 'utils/useObjectRef'
import { useNavItemContext } from '../NavItemContext'
import Styles from './Control.module.scss'

import { ControlProps } from './Types'
import useResponsiveDesign from 'hooks/useResponsiveDesign'

const Control = forwardRef<HTMLButtonElement, ControlProps>(({ onPress, icon: Icon, ...rest }, fRef) => {
  const ref = useObjectRef<HTMLButtonElement>(fRef)
  const { buttonProps } = useButton({ onPress }, ref)
  const navItemContext = useNavItemContext()
  const { isMobileMd } = useResponsiveDesign()

  return (
    <button
      className={cx(Styles.control, { [Styles.hidden]: !navItemContext.isHovered && !isMobileMd })}
      {...mergeProps(
        {
          onClick: (e: PointerEvent<HTMLElement>) => {
            e.stopPropagation()
            e.preventDefault()
            navItemContext.onPointerLeave?.(e)
          },
        },
        buttonProps,
      )}
      ref={ref}
      {...rest}
    >
      <Icon size={16} />
    </button>
  )
})

export { Control }
